<template>
  <div>
    <div class="previous" v-for="(product, counter) in products" v-bind:key="counter">
      <v-card class="mx-auto mb-5" outlined>
        <v-card-actions>
          <div class="overline">Nr.crt. {{ counter + 1 }}</div>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteProduct(counter)" color="orange">Sterge</v-btn>
        </v-card-actions>

        <v-list-item>
          <v-list-item-content>
            <v-row>
              <v-col cols="12" md="6">
                <ProductSearch :product.sync="products[counter]" v-if="!product.isNewProduct">
                </ProductSearch>
                <v-text-field v-if="product.isNewProduct" label="Denumire" v-model="product.name" :rules="requiredRules"
                  required>
                </v-text-field>
              </v-col>
              <v-col cols="12" :md="show ? 1 : 2">
                <v-text-field label="UM" v-model="product.um" :rules="requiredRules" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Cantitate" v-model="product.quantity" :rules="quantityRules(product)" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Pret Unitar" v-model="product.price" :rules="requiredNumberRules" required>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="1" v-if="show">
                <v-text-field label="TVA" v-model="product.vatValue" :rules="requiredNumberRules" required>
                </v-text-field>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </div>

    <v-layout justify-end>
      <v-btn justify-end @click="addProduct(true)" color="primary" class="mr-2">Produs Nou</v-btn>

      <v-btn justify-end @click="addProduct()" color="primary">Produs din Stoc</v-btn>
    </v-layout>
  </div>
</template>

<script>
import { hasAccess, PERMISSION_LEVEL_ADMIN } from '../utils/permissions';
import ProductSearch from './ProductSearch.vue';

export default {
  name: 'ProductsGroup',
  props: ['products'],
  components: {
    ProductSearch,
  },
  data() {
    return {
      show: hasAccess(PERMISSION_LEVEL_ADMIN),
      requiredRules: [
        (element) => {
          if (element.trim() === '') return 'Campul trebuie completat.';
          return true;
        },
      ],
      quantityRules: (product) => {
        return [
          (v) => !!v || isNaN(Number(v)) || 'Campul trebuie completat.',
          (v) => {
            if (product.stockId && Number(v) > product.stock.quantity) {
              return `Cantitatea indisponibila. In stoc: ${product.stock.quantity}`;
            }

            return true;
          },
        ];
      },
      requiredNumberRules: [
        (element) => {
          // eslint-disable-next-line no-restricted-globals
          if (!element || isNaN(Number(element)))
            return 'Campul trebuie completat';
          return true;
        },
      ],
    };
  },

  methods: {
    addProduct(isNewProduct = false) {
      this.products.push({
        isNewProduct,
        name: '',
        um: 'buc',
        quantity: 1,
        price: 0,
        vatValue: 21,
      });
    },
    deleteProduct(counter) {
      this.products.splice(counter, 1);
    },
  },
};
</script>
